// extracted by css-extract-rspack-plugin
export default {"container":"miuyWhoLHkEG8pt4"};